import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const useSeriesFields = () => {
    const { t } = useTranslation('common');
    const currentMonth = t('dashboard:displayControl.currentMonth', { month: dayjs(new Date()).format('MMM') });
    const lastMonth = t('dashboard:displayControl.lastMonth', {
        month: dayjs(new Date()).subtract(1, 'month').format('MMM'),
    });

    return {
        currentMonth,
        lastMonth,
    };
};

export default useSeriesFields;
